import useRestockLogsTable from "./useRestockLogsTable";
import secondaryComponents from "../..";
import { RoutedModal } from "../../../common";
import { RestockLogDetails } from "../RestockLogsDetails";

export const RestockLogsTable = ({
  metaDetails,
  stockHistory,
  handleFetchStockHistory,
  gotoPage,
}) => {
  const {
    instance,
    isFetchingProductDetails,
    selectedProduct,
    refetchSelectedProduct,
    openAddStockWidget,
    setOpenAddStockWidget,
    isFetchingViewProductDetails,
    viewSelectedProduct,
    refetchViewSelectedProduct,
    handleFetchproducts,
  } = useRestockLogsTable({
    stockHistory,
    handleFetchStockHistory: handleFetchStockHistory,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;
  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <h4 className="py-5 text-center">No Data Available</h4>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {stockHistory?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      {/* view stock modal */}
      <RoutedModal
        width={1200}
        headerTitle="Restock Details"
        isActive={openAddStockWidget.view !== null}
        closeModal={() =>
          setOpenAddStockWidget((prev) => ({ ...prev, view: null }))
        }
      >
        <secondaryComponents.LoaderHelper
          classNames="mt-5"
          isLoading={isFetchingViewProductDetails}
        >
          <RestockLogDetails
            closeWidget={() =>
              setOpenAddStockWidget((prev) => ({ ...prev, view: null }))
            }
            selectedProduct={viewSelectedProduct}
            handleFetchproducts={handleFetchStockHistory}
            refetchSelectedProduct={refetchViewSelectedProduct}
            openAddStockWidget={openAddStockWidget.view}
            stockHistory={stockHistory}
          />
        </secondaryComponents.LoaderHelper>
      </RoutedModal>

      {/* add stock modal */}
      <secondaryComponents.SideModal
        width={1400}
        isActive={openAddStockWidget.add !== null}
        closeModal={() =>
          setOpenAddStockWidget((prev) => ({ ...prev, add: null }))
        }
      >
        <secondaryComponents.LoaderHelper
          classNames="mt-5"
          isLoading={isFetchingProductDetails}
        >
          <secondaryComponents.AddProductStock
            closeWidget={() =>
              setOpenAddStockWidget((prev) => ({ ...prev, add: null }))
            }
            selectedProduct={selectedProduct}
            handleFetchproducts={handleFetchproducts}
            refetchSelectedProduct={refetchSelectedProduct}
          />
        </secondaryComponents.LoaderHelper>
      </secondaryComponents.SideModal>
    </>
  );
};
